import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import HeaderBar from '../../components/HeaderBar/HeaderBar'
import SearchBox from './Search/SearchBox'
import ResultsBox from './Results/Results'

export const DataGroupsPage: React.FC = () => {
    return (
        <Container fluid={true} className='wivi-container'>
            <Row>
            <Col xs={12}>
                <HeaderBar
                    origin='Data Archive'
                    routes={[
                        {
                            title: 'Data Groups'
                        }
                    ]}
                    help={{ title: 'Data Groups', text:
              <><div className='jumbotron' id='content'> <p>
            {' '}
            The Data Groups page is mostly equivalent to the data archive page,
            except it shows the groups of the stored collections to search through.{' '}
          </p>
           </div></>}}
                />
            </Col>
            </Row>
            <Row>
                <SearchBox />
            </Row>
            <Row>
                <ResultsBox />
            </Row>
        </Container>
    )
}

export default DataGroupsPage
